import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { extend } from 'underscore';
import { queryify } from '@bingads-webui/url-util';
import { Callout } from '@bingads-webui-react/callout';

function toUrl(template, scope, type) {
  const args = extend({
    aid: scope.values.aid,
    cid: scope.values.cid,
    cmpid: scope.values.campaignId,
    adgid: scope.values.adGroupId,
    type: type.replace('AdExtension', ''),
  });

  return queryify(template, args);
}

const rejectionReasonMap = {
  CampaignUserPaused: _TL_('You have paused this campaign, so no ads are running. To start running your ads, go to the Campaigns tab, select the check box for this campaign, and on the Edit menu, click Enable.'),
  AdGroupUserPaused: _TL_('You have paused this ad group, so no ads are running. To start running your ads, go to the Ad Groups tab, select the check box for this ad group, and then on the Edit menu, click Enable.'),
  AssociationDeleted: _TL_('This ad extension is not running because it is not associated with any campaigns.'),
  AdExtensionAssociationDeleted: _TL_('This ad extension and all its associations are not running because the ad extension has been deleted.'),
  ApplicationDestinationUrlMismatch: _TL_('The app/measurement URL for this app ID/package is incorrect. Please verify that following the App/Measurement URL leads to the correct app.'),
  EditorialPending: _TL_('This ad, keyword, product target, or ad extension is not running because it is still pending editorial review. Most reviews are completed within one business day.'),
};

export function showRejectionReason(event, model, scope, type, associationType, i18n) {
  const adextension = {
    extensionId: model.AdExtension.Id,
    version: model.AdExtension.Version,
    campaignId: model.VerticalSubAccount.Id,
    adGroupId: model.VerticalHotelGroup.Id,
    Id: model.Id,
    delivery: model.AdExtension.Delivery,
  };

  const reason = rejectionReasonMap[adextension.delivery];
  const activeElement = document && document.activeElement;

  if (reason) {
    const calloutContent = {
      className: 'callout-basic',
      popoverId: 'popover-basic',
      closeButton: false,
      content: i18n.getString(reason),
      focusLockContent: activeElement === event.target,
    };

    ReactDOM.render(
      <Callout
        target={event.target}
        show
        {...calloutContent}
      />,
      document.getElementById('rejectionContainer')
    );

    return;
  }

  let url = toUrl('/campaign/AdExtensions.m/GetRejectionReason', scope, type === 'sitelink' ? 'Sitelink2' : type);

  url = $.advertiser.setUrlParameter('adExtensionId', adextension.extensionId, url);
  url = $.advertiser.setUrlParameter('campaignId', scope.values.campaignId || adextension.campaignId, url);
  url = $.advertiser.setUrlParameter('adGroupId', scope.values.adGroupId || adextension.adGroupId, url);
  url = $.advertiser.setUrlParameter('version', adextension.version, url);
  url = $.advertiser.setUrlParameter('overrideAssociationType', associationType, url);
  url = $.advertiser.setUrlParameter('BidataNotRequired', true, url);

  $.advertiser.ajaxPost({
    url,
    data: {},
    ignoreBeforeAjax: true,
    dataType: 'html',
    onSuccess: (response) => {
      const calloutContent = {
        className: 'callout-basic',
        popoverId: 'popover-basic',
        closeButton: false,
        // eslint-disable-next-line react/no-danger
        content: <div dangerouslySetInnerHTML={{ __html: response }} />,
        focusLockContent: activeElement === event.target,
      };

      ReactDOM.render(
        <Callout
          target={event.target}
          show
          {...calloutContent}
        />,
        document.getElementById('rejectionContainer')
      );
    },
    onsuccessEventData: { event, rowId: adextension.Id },
  });
}

export function hideRejectionReason() {
  ReactDOM.unmountComponentAtNode(document.getElementById('rejectionContainer'));
}
